import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import { useNavigate } from 'react-router-dom';

const formatDate = (isoDateStr) => {
    const date = new Date(isoDateStr);
    return date.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
};

const isValidDate = (date) => {
    return date && !isNaN(new Date(date));
};

const TeamAttendance = () => {
    const { isSidebarOpen } = useSidebar();
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [attendances, setAttendances] = useState([
        // Sample data (replace with actual data)

    ]);
    const [filteredAttendances, setFilteredAttendances] = useState(attendances);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const url = process.env.REACT_APP_LINK
    const navigate = useNavigate();
    // Effect to handle filtering
    useEffect(() => {
        const filtered = attendances.filter((attendance) =>
            Object.values(attendance).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredAttendances(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, attendances]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredAttendances.length / itemsPerPage);
    const currentData = filteredAttendances.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const fetchData = async () => {
        try {
            const response = await fetch(`${url}/staffattendance/all/${isLoggedIn.user_id}`);
            let res = await response.json();

            // Process the data to get the latest entry for each staff_id
            const latestData = res.reduce((acc, curr) => {
                // Assuming each entry has 'staff_id' and 'checkin_date'
                const staffId = curr.staff_id;
                const checkinDate = new Date(curr.checkin_date);

                if (!acc[staffId] || checkinDate > new Date(acc[staffId].checkin_date)) {
                    acc[staffId] = curr;
                }

                return acc;
            }, {});

            // Convert the object of latest entries to an array
            const filteredData = Object.values(latestData);

            console.log(filteredData);
            setAttendances(filteredData);
        } catch (error) {
            console.log(error);
        }
    };

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h1 className="dashboard-title">Team Attendance</h1>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Team Attendance Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Selfie</th>
                                <th>Staff Name</th>
                                <th>Staff ID</th>
                                <th>Check-in Location</th>
                                <th>Check-out Location</th>
                                <th>Check-in Date Time</th>
                                <th>Check-out Date Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((attendance, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img
                                                src={`${url}/${attendance.selfie}`}
                                                alt="Staff Selfie"
                                                style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                                            />
                                        </td>
                                        <td style={{cursor:"pointer"}} onClick={() =>navigate(`/team-attendance/${attendance.staff_name}/${attendance.staff_id}`)}>{attendance.staff_name}</td>
                                        <td>{attendance.staff_id}</td>
                                        <td>{attendance.checkin_location}</td>
                                        <td>{attendance.checkout_location || "-"}</td>
                                        <td>{formatDate(attendance.checkin_date)}</td>
                                        {
                                            isValidDate(attendance.checkout_date) ? (
                                                <td>{formatDate(attendance.checkout_date)}</td>
                                            ) : (
                                                <td>-</td>
                                            )
                                        }


                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>
                                        No attendance records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    );
};

export default TeamAttendance;
